








import Vue from 'vue'
import { createComponent } from '@vue/composition-api'

export default createComponent({
    components: {},
    setup(props, setupContext) {
        return {}
    },
})
